import React, { useEffect, useRef, useState } from 'react';
import { BadgeCheck, X } from 'lucide-react';
import { recentSales, soldToday, spotsTotal } from '../data/socialProof';
import { todayPrice } from '../data/valueStack';
const PRODUCT_THUMB = 'https://cdn.magicpatterns.com/uploads/tkNTLZc3GVXwYzNyi9EpAt/peptides-mockup.png';
const FIRST_DELAY = 6000;
const NEXT_DELAY = 9500;
const VISIBLE_TIME = 5400;
export function SaleNotification() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const hasShownRef = useRef(false);
  useEffect(() => {
    if (isDismissed) return;
    const delay = isVisible ? VISIBLE_TIME : hasShownRef.current ? NEXT_DELAY : FIRST_DELAY;
    const timeout = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        return;
      }
      if (hasShownRef.current) {
        setIndex(current => (current + 1) % recentSales.length);
      }
      hasShownRef.current = true;
      setIsVisible(true);
    }, delay);
    return () => window.clearTimeout(timeout);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const sale = recentSales[index];
  return <div role="status" aria-live="polite" className={`ease-luxe fixed inset-x-3 bottom-3 z-40 transition-[opacity,transform] duration-500 sm:inset-x-auto sm:bottom-auto sm:right-5 sm:top-[5.75rem] sm:w-[21rem] ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0 sm:-translate-y-2 sm:translate-x-0'}`} data-id="element-257" data-mp="r4wdw6iq2dy3">
      <div className="relative flex items-center gap-3 overflow-hidden rounded-xl border border-gold-400/35 bg-ink-950/95 p-2.5 pr-9 shadow-[0_24px_50px_-20px_rgba(0,0,0,0.95)] backdrop-blur-sm sm:p-3 sm:pr-10" data-id="element-258" data-mp="860nl69zijpj">
        <img src={PRODUCT_THUMB} alt="" width={44} height={44} loading="lazy" decoding="async" className="h-11 w-11 shrink-0 rounded-lg border border-gold-400/30 object-cover" data-id="element-259" data-mp="22kb852jjqrpi" />

        <div className="min-w-0 flex-1" data-id="element-260" data-mp="3aip5o9zk3szw">
          <p className="flex items-center gap-1.5 text-[12.5px] font-semibold leading-tight text-[#eae7e1]" data-id="element-261" data-mp="3ahnwkb23pgkt">
            <span className="truncate" data-id="element-262" data-mp="36hnfsjrj4tal">{sale.name}</span>
            <BadgeCheck className="h-3.5 w-3.5 shrink-0 text-[#7fbf8f]" strokeWidth={1.9} aria-hidden="true" data-id="element-263" data-mp="31iakrbqi8fwx" />
          </p>
          <p className="mt-0.5 truncate text-[11.5px] leading-tight text-[#a7adb8]" data-id="element-264" data-mp="24qa39ghy9mx">
            acaba de asegurar su acceso · <span className="text-gold-300" data-id="element-265" data-mp="3pfq04l94u222">${todayPrice}</span>
          </p>
          <p className="mt-1 truncate font-mono text-[9.5px] uppercase tracking-[0.08em] text-[#6f7684]" data-id="element-266" data-mp="3pdmxn1qsmggg">
            {sale.location} · {sale.timeAgo} · {soldToday}/{spotsTotal} cupos
          </p>
        </div>

        <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar notificación de compra" className="absolute right-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-md text-[#6f7684] transition-colors hover:bg-white/[0.06] hover:text-bone focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-400/60" data-id="element-267" data-mp="h06b5yfhv5st">
          <X className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-268" data-mp="12c55rtvpg5dx" />
        </button>

        <span className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold-400/60 to-transparent" aria-hidden="true" data-id="element-269" data-mp="17ayllsygs8h9" />
      </div>
    </div>;
}